/* eslint-disable react/no-multi-comp
  made by Mateusz Janeczek
  GAIP Sp. z o.o.
*/
import React from 'react';
import { connect } from 'react-redux';
import s from './DataManagementView.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormGroup, DropdownButton, FormControl, MenuItem, InputGroup, Form, Col } from 'react-bootstrap';
import { createNewLayer } from '../../../../../actions/district';

//komponent dziecko =============================================================
class DWAtrybut extends React.Component {

  render(){
    var precyzjaMIN = this.props.listaAtrybutow.dataType !== 'double' ?
        <input type="number" value={this.props.listaAtrybutow.precisionMin} placeholder="Precyzja MIN" className="form control btn btn-default" disabled /> :
        <input onChange={this.props.onChangePrecisionMin} value={this.props.listaAtrybutow.precisionMin} type="number" placeholder="Precyzja MIN" className="form control btn btn-default" />;
    var precyzjaMAX = this.props.listaAtrybutow.dataType !== 'double' ?
        <input type="number" value={this.props.listaAtrybutow.precisionMax} placeholder="Precyzja MAX" className="form control btn btn-default" disabled /> :
        <input onChange={this.props.onChangePrecisionMax} value={this.props.listaAtrybutow.precisionMax} type="number" placeholder="Precyzja MAX" className="form control btn btn-default" />;
    return (
      <div>
        <div>
          <form className="form-inline">
            <div className="form-group">
              <label htmlFor='numer'><i className="glyphicon">{this.props.nr+1}   :</i></label>
              <input value={this.props.listaAtrybutow.atrName} onChange={(e)=>this.props.onChangeAtrName(e)} type="text" placeholder="Nazwa atrybutu" className="form control btn btn-default"/>
              <DropdownButton title={this.props.listaAtrybutow.dataType} id="bg-nested-dropdown">
                <MenuItem onSelect={(e)=>this.props.onChangeDataType(e)} eventKey='varchar'>varchar</MenuItem>
                <MenuItem onSelect={(e)=>this.props.onChangeDataType(e)} eventKey='double'>double</MenuItem>
                <MenuItem onSelect={(e)=>this.props.onChangeDataType(e)} eventKey='data'>data</MenuItem>
              </DropdownButton>
              {precyzjaMIN}{precyzjaMAX}
              <button onClick={this.props.onDeleteOneAtribute} className="btn btn-danger" type="submit">Usuń atrybut</button>
              <div style={{textAlign: 'left'}}>
                <input type="checkbox" /> Wartość unikalna
              </div>
            </div>
          </form>
        </div>
        <br />
      </div>
    )
  }
}
//komponent rodzic ==============================================================
class AddLayers extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      layerName: '',
      geometry: 'Wybierz typ geometrii',
      epsg: '',
      listaAtrybutow: [],
    };
  }

  onChangePrecisionMin = (e) =>{
    this.setState({
      precisionMax: e.target.value,
    })
  }

  onChangePrecisionMax = (e) =>{
    this.setState({
      precisionMax: e.target.value,
    })
  }

  onAddAttribute = (e) => {
    e.preventDefault();
    this.setState({
      listaAtrybutow: this.state.listaAtrybutow.concat({
        atrName: '',
        dataType: 'Wybierz precyzję',
        precisionMin: '',
        precisionMax: '',
      })
    });
  }

  onDeleteOneAtribute = (i) => {
    let oldList = this.state.listaAtrybutow.slice();
    oldList.splice(i, 1);
    this.setState({ listaAtrybutow: oldList })
  }

  onDeleteAttribute = () => {
    this.setState({
      listaAtrybutow: []
    });
  }

  handleChangeDropdown = (e) => {
    this.setState({ geometry: e.target.value });
  }

  handleChangeInput = (e) => {
    this.setState({ layerName: e.target.value });
  }
  handleChangeEpsg = (e) => {
    this.setState({ epsg: e.target.value });
  }

  onChangeAtrName = (e, i) =>{
    const oldList = this.state.listaAtrybutow.slice();
    const newList = _.filter(oldList, (o, index) => {
      if (index === i) {
        o['atrName'] = e.target.value;
        return o;
      }
      return o;
    });
    this.setState({ listaAtrybutow: newList })
  }

  onChangeDataType = (e, i) =>{
    const oldList = this.state.listaAtrybutow.slice();
    const newList = _.filter(oldList, (o, index) => {
      if (index === i) {
        o['dataType'] = e;
        if (e == 'varchar'){
          o['precisionMin'] = 0;
          o['precisionMax'] = 255;
        }
        else if (e == 'data'){
          o['precisionMin'] = 0;
          o['precisionMax'] = 0;
        }
        else if (e == 'double'){
          o['precisionMin'] = '';
          o['precisionMax'] = '';
        }
        return o;
      }
      return o;
    });
    this.setState({ listaAtrybutow: newList });
  }

  onChangePrecisionMin = (e, i) =>{
    const oldList = this.state.listaAtrybutow.slice();
    const newList = _.filter(oldList, (o, index) => {
      if (index === i) {
        o['precisionMin'] = e.target.value;
        return o;
      }
      return o;
    });
    this.setState({ listaAtrybutow: newList });
  }

  onChangePrecisionMax = (e, i) =>{
    const oldList = this.state.listaAtrybutow.slice();
    const newList = _.filter(oldList, (o, index) => {
      if (index === i) {
        o['precisionMax'] = e.target.value;
        return o;
      }
      return o;
    });
    this.setState({ listaAtrybutow: newList });
  }

  onCreateLayerButtonClick = () => {
    this.props.createNewLayer(this.props.district.prefix, this.state)
  }

  render() {
    return (
      <div style={{ width: '100%', textAlign: 'center' }}>
        <div className="col-xs-12">
          <Form componentClass="fieldset" inline>
            <label>Nazwa warstwy&nbsp;&nbsp;&nbsp;</label>
            <FormGroup controlId="nazwa">
              <FormControl type="text" placeholder="Wprowadź nazwę" value={this.state.layerName} onChange={this.handleChangeInput} />
              <FormControl.Feedback />
              {'  '}
              <DropdownButton title={this.state.geometry} id="bg-nested-dropdown">
                <MenuItem onClick={() => this.setState({ geometry: 'Punkt' })} eventKey="1">Punkt</MenuItem>
                <MenuItem onClick={() => this.setState({ geometry: 'Linia' })} eventKey="2">Linia</MenuItem>
                <MenuItem onClick={() => this.setState({ geometry: 'Poligon' })} eventKey="3">Poligon</MenuItem>
                <MenuItem onClick={() => this.setState({ geometry: 'Multi Poligon' })} eventKey="4">Multi Poligon</MenuItem>
              </DropdownButton>
            </FormGroup>
            {' '}
            <FormGroup controlId="epsginput">
              {' '}
              <FormControl type="number" placeholder="Pole EPSG" value={this.state.epsg} onChange={this.handleChangeEpsg} />
              <FormControl.Feedback />
            </FormGroup><br/><br/>
            <FormGroup controlId="wyslij">
              <InputGroup>
                <button className="btn btn-danger" type="submit" onClick={(e) => this.onAddAttribute(e)}>Dodaj atrybut</button>
              </InputGroup>
            </FormGroup>
          </Form><hr/>
        </div>
        {(this.state.listaAtrybutow.length) ? this.state.listaAtrybutow.map((attr, index) => {
          return (
            <DWAtrybut
              nr={index}
              onChangeAtrName={(e)=>this.onChangeAtrName(e, index)}
              onChangeDataType={(e)=>this.onChangeDataType(e, index)}
              onChangePrecisionMin={(e) => this.onChangePrecisionMin(e, index)}
              onChangePrecisionMax={(e) => this.onChangePrecisionMax(e, index)}
              key={index}
              listaAtrybutow={this.state.listaAtrybutow[index]}
              nrAttr={attr.nrAttr}
              onDeleteOneAtribute={()=>this.onDeleteOneAtribute(index)}
            />
          )
        }) : null}
        <FormGroup controlId="formHorizontalButtons">
          {(this.state.listaAtrybutow.length) ?
          <div>
          <Col sm={4}></Col>
          <Col sm={2}>
            <input onClick={this.onDeleteAttribute} type="button" id="btn-login" className={"btn btn-danger btn-md btn-block"} value="Wyczyść" />
          </Col>
          </div>
          : <Col sm={5}></Col>}
          <Col sm={2}>
            <input type="submit" onClick={this.onCreateLayerButtonClick} id="btn-login" className={"btn btn-danger btn-md btn-block"} value="Wyślij" />
          </Col>

        </FormGroup>
      </div>
    )
  }
}


const mapState = (state) => ({
  district: state.district.district,
});
const mapDispatch = {
  createNewLayer
};

export default withStyles(s)(connect(mapState, mapDispatch)(AddLayers));



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/DataManagementView/AddLayers.js